import React from 'react';
import styled from 'styled-components';

import folder from 'assets/windowsIcons/folder.png';

const TRASH = [
  { name: 'paper_hands.txt', size: '1 KB', deleted: '2025' },
  { name: 'internet_v1.bak', size: '2,000 KB', deleted: '2025' },
  { name: 'jpeg_of_my_portfolio_2022.bmp', size: '4,096 KB', deleted: '2022' },
  { name: 'sell_signal.exe', size: '666 KB', deleted: 'never ran' },
  { name: 'roadmap_v1_final_FINAL(2).doc', size: '12 KB', deleted: '2025' },
];

export default function RecycleBin() {
  return (
    <Div>
      <div className="rb__bar">
        Recycle Bin — these files are gone and they are not coming back.
      </div>
      <table className="rb__table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Size</th>
            <th>Date deleted</th>
          </tr>
        </thead>
        <tbody>
          {TRASH.map(f => (
            <tr key={f.name}>
              <td>
                <img src={folder} alt="" /> {f.name}
              </td>
              <td>{f.size}</td>
              <td>{f.deleted}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="rb__foot">5 object(s) · Empty Recycle Bin is disabled: we hold.</div>
    </Div>
  );
}

const Div = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #000;
  font-family: Tahoma, sans-serif;
  font-size: 11px;

  .rb__bar {
    padding: 6px 10px;
    background: linear-gradient(to bottom, #f4ffd0, #dfffa0);
    border-bottom: 1px solid #8fb800;
  }
  .rb__table {
    flex: 1;
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      text-align: left;
      padding: 4px 10px;
      border-bottom: 1px solid #eee;
    }
    th {
      background: #f5f5f5;
      border-bottom: 1px solid #ccc;
      font-weight: normal;
      color: #555;
    }
    img {
      width: 14px;
      height: 14px;
      vertical-align: -2px;
      margin-right: 4px;
    }
  }
  .rb__foot {
    padding: 4px 10px;
    border-top: 1px solid #ccc;
    background: #f5f5f5;
    color: #555;
  }
`;
